function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1839_5825)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.494 22.697l-5.599-3.053a5.334 5.334 0 110-7.287l5.6-3.053a5.333 5.333 0 111.279 2.34l-5.6 3.053c.215.855.215 1.75 0 2.605l5.598 3.054a5.333 5.333 0 11-1.278 2.34v.001zM8 18.667a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.333zm14.667-8a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.333zm0 16a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1839_5825"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));